import React from 'react';
import BackButton from '../BackButton';
import { Container } from './styles';

const SubPageHeader: React.FC = () => {
  return <Container>
      <BackButton />
  </Container>;
}

export default SubPageHeader;